<script setup lang="ts">
interface Perk {
  title: string
  description: string
  titlePrefix?: string
  titleHighlight?: string
  titleSuffix?: string
}

defineProps<{
  perks: Perk[]
}>()
</script>

<template>
  <ul class="content-padding">
    <li v-for="(perk, index) in perks" :key="index">
      <h2>
        <template v-if="perk.titleHighlight">
          {{ perk.titlePrefix }}<span class="accent">{{ perk.titleHighlight }}</span>{{ perk.titleSuffix }}
        </template>
        <template v-else>{{ perk.title }}</template>
      </h2>
      <p>{{ perk.description }}</p>
    </li>
  </ul>
</template>

<style scoped>

h2 {
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  font-size: 14px;
  text-align: center;
  white-space: pre-line;
}

h2 .accent {
  color: var(--accent-red);
}

p {
  margin-top: .5rem;
  font-size: 12px;
  text-align: center;
}

ul {
  display: flex;
  flex-wrap: nowrap;
  gap: 1rem;
  justify-content: center;
  list-style: none;
  padding: 0;

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
}

li {
  flex: 0 0 30%;
  max-width: 25%;
  background-color: var(--white);
  border: 1px solid var(--ligth-blue);
  border-radius: 1.25rem;
  padding: .75rem;
  text-align: center;

  @media (max-width: 768px) {
    flex: 0 0 calc(50% - .5rem);
    max-width: calc(50% - .5rem);
  }
}

</style>